import * as React from 'react';
import notify from '../../../shared/feedback/notifications';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { unimpersonate, unImpersonateCountry } from '../../../actions/userActions';
import { Translate } from '../../../shared/LanguageService';
import { getUser, getUserImpersonatedCountry } from '../../../reducers/userReducer';
import { getSite } from '../../../reducers/siteReducer';
import { getSystemVersion } from '../../../reducers/sysInfoReducer';
import PhotoNavbar from './photo/PhotoNavbar';
import ScandphotosNavbar from './scandphotos/ScandphotosNavbar';
import { getLanguage } from '../../../reducers/languageReducer';
import ImpersonationStore from '../../../shared/ImpersonationStore';

class Header extends React.Component<any, any> {
    state = {
        impersonation: false,
        displayImpersonationForm: false,
        displayCountryImpersonationForm: false,
        showCreateGenericModal: false,
        navExpanded: false
    };

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (this.state.impersonation !== nextProps.impersonation) {
            this.setState({ impersonation: nextProps.impersonation });
        }
    }

    unimpersonate = () => {
        const { history, actions } = this.props;

        actions.unimpersonate().then(() => {
            notify.success(Translate('impersonation/notification/left-impersonation'));
            history.push('/');
        });
    };

    unimpersonateCountry = () => {
        const { history, actions } = this.props;
        history.push('/');

        actions.unimpersonateCountry();
        notify.success(Translate('impersonation/notification/left-country-impersonation'));
    };

    navigateTo = (route: string) => {
        const { history } = this.props;
        this.setState({ navExpanded: false }, () => {
            history.push(route);
        });
    };

    getLoginName = () => {
        const { user, impersonatedCountry } = this.props;

        if (user.details.referer) {
            return <span className="referer_label">{user.details.referer}</span>;
        }
        let country = impersonatedCountry ? ` @ ${impersonatedCountry.name}` : '';
        return (
            <span>
                {Translate('header/nav/logged-in-as')}: {user.details.name + country}
            </span>
        );
    };

    setDisplayImpersonationForm = (mode: boolean) => {
        this.setState({ displayImpersonationForm: mode, navExpanded: true });
    };

    setDisplayCountryImpersonationForm = (mode: boolean) => {
        this.setState({
            displayCountryImpersonationForm: mode,
            navExpanded: true
        });
    };

    toggleCreateGenericOrderModal = () => {
        this.setState((state) => ({
            showCreateGenericModal: !state.showCreateGenericModal
        }));
    };

    /**
     * TODO: When not needed for scandphotos,
     * and new navbar is operational this should be removed.
     */
    closeCreateGenericModalAndNavigate = (path: string) => {
        const { history } = this.props;
        this.setState({ showCreateGenericModal: false }, () => {
            history.push(path);
        });
    };

    toggleNavbar = () => {
        this.setState((state) => ({ navExpanded: !state.navExpanded }));
    };

    render() {
        const {
            navExpanded,
            displayImpersonationForm,
            displayCountryImpersonationForm,
            showCreateGenericModal
        } = this.state;
        const { site, user, systemVersion, impersonation, impersonatedCountry } = this.props;

        if (site === 'se360' || site === 'zentuvo') {
            return (
                <PhotoNavbar systemVersion={systemVersion} site={site} />
            );
        } else if (site === 'scandphotos') {
            return (
                <ScandphotosNavbar
                    toggleNavbar={this.toggleNavbar}
                    expanded={navExpanded}
                    user={user}
                    systemVersion={systemVersion}
                    toggleCreateGenericOrderModal={this.toggleCreateGenericOrderModal}
                    displayImpersonationForm={displayImpersonationForm}
                    setDisplayImpersonationForm={this.setDisplayImpersonationForm}
                    displayCountryImpersonationForm={displayCountryImpersonationForm}
                    setDisplayCountryImpersonationForm={this.setDisplayCountryImpersonationForm}
                    loginName={this.getLoginName()}
                    impersonation={impersonation}
                    impersonatedCountry={impersonatedCountry}
                    unImpersonate={this.unimpersonate}
                    unImpersonateCountry={this.unimpersonateCountry}
                    showCreateGenericModal={showCreateGenericModal}
                    closeCreateGenericModalAndNavigate={this.closeCreateGenericModalAndNavigate}
                />
            );
        } else {
            throw new Error(
                `Unsupported site ${site} provided to <Header />, only 'se360', 'zentuvo' and 'scandphotos' are supported!`
            );
        }
    }
}

function mapStateToProps(state: any) {
    return {
        systemVersion: getSystemVersion(state),
        impersonation: ImpersonationStore.isImpersonated(),
        impersonatedCountry: getUserImpersonatedCountry(state),
        site: getSite(state),
        user: getUser(state),
        language: getLanguage(state)
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            unimpersonate: () => dispatch(unimpersonate()),
            unimpersonateCountry: () => dispatch(unImpersonateCountry())
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
